<template>
  <div class="my-select">
    <search-customer-seller :show-goback="false">
      <template v-if="isAvaliable" #right-actions>
        <change-password-control />
        <data-update-step-launcher v-if="isRegionalManager" :is-large="true" />
        <v-btn
          class="mr-1 text-red text-none wp-150"
          :to="{ name: 'DirectorChannelSelection' }"
          rounded
          outlined
        >
          Canal
        </v-btn>
      </template>
    </search-customer-seller>
  </div>
</template>

<script>
  import SearchCustomerSeller from '@/components/SearchCustomerSeller.vue';
  import ChangePasswordControl from '@/components/ChangePasswordControl.vue';
  import DataUpdateStepLauncher from '@/template/partials/stepsAfterLogin/DataUpdateStepLauncher.vue';
  export default {
    name: 'SearchBar',
    components: {
      SearchCustomerSeller,
      ChangePasswordControl,
      DataUpdateStepLauncher,
    },
    data() {
      return {};
    },
    computed: {
      isAvaliable() {
        switch (this.$route.meta.role) {
          case 'Director':
            if (
              this.$hasAnyRole([
                'Director',
                'IELDirector',
                'IELCommercialPR',
                'IELCommercialDT',
                'Subdirector',
                'DirectorNoCommercial',
                'SubDirectorPRNoCommercial',
                'SubDirectorDTNoCommercial',
              ])
            )
              return true;
            break;
          case 'Regional':
            return this.isRegionalManager;
        }
        return false;
      },
      isRegionalManager() {
        return this.$hasAnyRole([
          'Regional',
          'RegionalManager',
          'IELRegManager',
        ]);
      },
    },
  };
</script>
